import { createContext, useContext, type ReactNode } from "react";
import type { PortalApiClient } from "./PortalApiClient";

const ApiClientContext = createContext<PortalApiClient | undefined>(undefined);

export function ApiClientProvider({
  client,
  children,
}: {
  client: PortalApiClient;
  children: ReactNode;
}) {
  return (
    <ApiClientContext.Provider value={client}>{children}</ApiClientContext.Provider>
  );
}

export function useApiClient(): PortalApiClient {
  const client = useContext(ApiClientContext);
  if (!client) {
    throw new Error("useApiClient must be used within an ApiClientProvider");
  }
  return client;
}
